(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-table-of-contents"] && !window.DesignMode) return;
  try {
    

    function setEventListeners ( ) 
    {
        window.addEventListener('resize', function ( ) {
            var currentWidth = window.innerWidth;
            if ( currentWidth <= 769 )
            {
              startAccordian( );
            }
            if ( currentWidth < 769 )
            {
                var subsections = document.getElementsByClassName( 'toc__subsections' );
                subsections.style.maxHeight = subsections.scrollHeight + "px";
            }
          });
          var currentWidth = window.innerWidth;
          if ( currentWidth <= 769 )
          {
            startAccordian( );
          }

    }

    function startAccordian ( )
    {
        var sections = document.getElementsByClassName( 'toc__section' );
        for ( var i = 0; i < sections.length; i++ )
        {
            sections[ i ].addEventListener( "click", function( ) 
            {
                var subsections = this.nextElementSibling;
                var close = this.querySelector( '.toc__section__close' );
                if ( subsections.style.maxHeight )
                {
                    subsections.style.maxHeight = null;
                    close.classList.add( 'toc__section__close--active' );
                }
                else
                {
                    subsections.style.maxHeight = subsections.scrollHeight + "px";
                    close.classList.remove( 'toc__section__close--active' );
                }   
            });
        }
    }

    setEventListeners( );


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
